import { useRoute, useRouter } from "@nuxtjs/composition-api";
import { useConfigStore } from "@wemade-vsf/core";
const nonFilters = /* @__PURE__ */ new Set([
  "page",
  "sort",
  "term",
  "itemsPerPage",
  "utm_source",
  "fbclid",
  "utm_id",
  "utm_term",
  "utm_campaign",
  "utm_medium",
  "utm_content",
  "utm_agid",
  "gclid",
  "campaignname",
  "device",
  "placement",
  "creative",
  "matchtype",
  "keyword",
  "productid",
  "adtype",
  "merchantid",
  "nyhetsbrev",
  "+nyhetsbrev"
]);
function reduceFilters(query) {
  return (prev, curr) => {
    const makeArray = Array.isArray(query[curr]) || nonFilters.has(curr);
    return {
      ...prev,
      [curr]: makeArray ? query[curr] : [query[curr]]
    };
  };
}
function useUiHelpers() {
  const route = useRoute();
  const router = useRouter();
  const configStore = useConfigStore();
  let { query: routerQuery } = route.value;
  const resolveQuery = () => {
    if (typeof window !== "undefined") {
      routerQuery = router.resolve((window.location.pathname + window.location.search).slice(1)).route.query;
    }
    return routerQuery;
  };
  const getFiltersDataFromUrl = (onlyFilters = false) => {
    const currentQuery = resolveQuery();
    return Object.keys(currentQuery).filter((f) => onlyFilters ? !nonFilters.has(f) : f).reduce(reduceFilters(currentQuery), {});
  };
  const getFacetsFromURL = (defaults) => {
    var _a, _b;
    const defaultItemsPerPage = ((_a = configStore.storeConfig) == null ? void 0 : _a.grid_per_page) || 12;
    const currentQuery = resolveQuery();
    return {
      filters: getFiltersDataFromUrl(true),
      itemsPerPage: Number.parseInt(currentQuery.itemsPerPage, 10) || defaultItemsPerPage,
      page: Number.parseInt(currentQuery.page, 10) || 1,
      sort: (_b = currentQuery.sort) != null ? _b : (defaults == null ? void 0 : defaults.sort) ? defaults.sort : "",
      term: currentQuery.term
    };
  };
  const changeSearchTerm = async (term, forcePush = false) => {
    if (forcePush) {
      await router.push({ query: { ...routerQuery, term } });
    } else {
      const routeData = router.resolve({
        query: {
          ...getFiltersDataFromUrl(),
          term
        }
      });
      console.log(routeData.href);
      window.history.pushState({}, null, routeData.href);
    }
  };
  const getSearchTermFromUrl = () => {
    var _a;
    const currentQuery = resolveQuery();
    return {
      page: Number.parseInt(currentQuery.page, 10) || 1,
      sort: (_a = currentQuery.sort) != null ? _a : "",
      filters: getFiltersDataFromUrl(true),
      itemsPerPage: Number.parseInt(currentQuery.itemsPerPage, 10) || 10,
      term: currentQuery.term
    };
  };
  const getCatLink = (category) => `/${category.url_path}${category.url_suffix || ""}`;
  const changeSorting = async (sort, forcePush = true) => {
    if (forcePush) {
      await router.push({ query: { ...routerQuery, sort } });
    } else {
      const routeData = router.resolve({
        query: {
          ...getFiltersDataFromUrl(),
          sort
        }
      });
      window.history.pushState({}, null, routeData.href);
    }
  };
  const changeFilters = async (filters, forcePush = true) => {
    const query = {
      ...getFiltersDataFromUrl(false),
      ...filters
    };
    if (forcePush) {
      await router.push({ query });
    } else {
      const routeData = router.resolve({ query });
      window.history.pushState({}, null, routeData.href);
    }
  };
  const clearFilters = async (forcePush = true) => {
    if (forcePush) {
      await router.push({
        query: {}
      });
    } else {
      const routeData = router.resolve({
        query: {}
      });
      window.history.pushState({}, null, routeData.href);
    }
  };
  const changeItemsPerPage = async (itemsPerPage, forcePush = true) => {
    const query = {
      ...getFiltersDataFromUrl(false),
      itemsPerPage: itemsPerPage.toString(10),
      page: "0"
    };
    if (forcePush) {
      await router.push({ query });
    } else {
      const routeData = router.resolve({ query });
      window.history.pushState({}, null, routeData.href);
    }
  };
  const changePage = async (page, forcePush = true) => {
    const query = {
      ...getFiltersDataFromUrl(false),
      page: page.toString()
    };
    if (forcePush) {
      await router.push({ query });
    } else {
      const routeData = router.resolve({ query });
      window.history.pushState({}, null, routeData.href);
    }
  };
  const setTermForUrl = async (term) => {
    await router.push({
      query: {
        ...getFiltersDataFromUrl(false),
        term: term || void 0
      }
    });
  };
  const isFacetColor = (facet) => facet.id === "color";
  const isFacetCheckbox = () => false;
  return {
    changeFilters,
    changeItemsPerPage,
    changeSearchTerm,
    changeSorting,
    clearFilters,
    getCatLink,
    getFacetsFromURL,
    getSearchTermFromUrl,
    isFacetCheckbox,
    isFacetColor,
    setTermForUrl,
    changePage
  };
}
export * from "./Params";
export * from "./useUiHelpers";
var useUiHelpers_default = useUiHelpers;
export {
  useUiHelpers_default as default,
  useUiHelpers
};
